"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.analytics = void 0;
var store_1 = require("./store");
require("isomorphic-fetch");
var Category;
(function (Category) {
    Category["Error"] = "Error";
    Category["TWAPPanel"] = "TWAPPanel";
    Category["OrdersPanel"] = "OrdersPanel";
    Category["ConfirmationPanel"] = "ConfirmationPanel";
    Category["PageView"] = "onTwapPageView";
})(Category || (Category = {}));
var onLimitToggleClick = function (isLimitOrder) {
    sendAnalyticsEvent(Category.TWAPPanel, "onLimitToggleClick", { isLimitOrder: isLimitOrder });
};
var uiCrashed = function (location, error) {
    sendAnalyticsEvent(Category.Error, "UI crashed", { location: location, message: error.message, stack: error.stack });
};
var onSrcTokenClick = function (symbol) {
    sendAnalyticsEvent(Category.TWAPPanel, "onSrcTokenClick", { symbol: symbol });
};
var onDstTokenClick = function (symbol) {
    sendAnalyticsEvent(Category.TWAPPanel, "onDstTokenClick", { symbol: symbol });
};
var onCustomIntervalClick = function () {
    sendAnalyticsEvent(Category.TWAPPanel, "onCustomIntervalClick");
};
var onApproveClick = function (amount) {
    sendAnalyticsEvent(Category.TWAPPanel, "onApproveClick", { amount: amount.toString() });
};
var onApproveSuccess = function () {
    sendAnalyticsEvent(Category.TWAPPanel, "onApproveSuccess");
};
var onWrapClick = function (amount) {
    sendAnalyticsEvent(Category.TWAPPanel, "onWrapClick", { amount: amount.toString() });
};
var onWrapSuccess = function () {
    sendAnalyticsEvent(Category.TWAPPanel, "onWrapSuccess");
};
var onConfirmationCreateOrderClick = function () {
    var _a, _b;
    var lib = store_1.useTwapStore.getState().lib;
    var srcToken = store_1.useTwapStore.getState().srcToken;
    var dsToken = store_1.useTwapStore.getState().dstToken;
    sendAnalyticsEvent(Category.ConfirmationPanel, "onConfirmationCreateOrderClick", {
        exchangeAddress: lib === null || lib === void 0 ? void 0 : lib.config.exchangeAddress,
        srcToken: (_a = store_1.useTwapStore.getState().srcToken) === null || _a === void 0 ? void 0 : _a.address,
        dstToken: (_b = store_1.useTwapStore.getState().dstToken) === null || _b === void 0 ? void 0 : _b.address,
        srcTokenAmount: (0, store_1.amountUi)(srcToken, store_1.useTwapStore.getState().getSrcAmount()),
        tradeSize: (0, store_1.amountUi)(srcToken, store_1.useTwapStore.getState().getSrcChunkAmount()),
        minAmountOut: (0, store_1.amountUi)(dsToken, store_1.useTwapStore.getState().getDstAmount()),
        deadline: store_1.useTwapStore.getState().getDeadline(),
        tradeInterval: store_1.useTwapStore.getState().getFillDelayUiMillis(),
        totalTrades: store_1.useTwapStore.getState().getChunks(),
    });
};
var onODNPClick = function () {
    sendAnalyticsEvent(Category.OrdersPanel, "onODNPClick");
};
var onModuleLoad = function () {
    sendAnalyticsEvent(Category.PageView, "onModuleLoad");
};
var onTwapPageView = function () {
    sendAnalyticsEvent(Category.PageView, "onTwapPageView");
};
var onCreateOrderSuccess = function (orderId) {
    sendAnalyticsEvent(Category.ConfirmationPanel, "onCreateOrderSuccess", { orderId: orderId });
};
var onCreateOrderError = function (message) {
    sendAnalyticsEvent(Category.Error, "onCreateOrderError", { message: message });
};
var onWrapError = function (message) {
    sendAnalyticsEvent(Category.Error, "onWrapError", { message: message });
};
var onApproveError = function (message) {
    sendAnalyticsEvent(Category.Error, "onApproveError", { message: message });
};
var onCancelOrderClick = function (orderId) {
    sendAnalyticsEvent(Category.OrdersPanel, "onCancelOrderClick", { orderId: orderId });
};
var onCancelOrderSuccess = function (orderId) {
    sendAnalyticsEvent(Category.OrdersPanel, "onCancelOrderSuccess", { orderId: orderId });
};
var onCancelOrderError = function (error) {
    sendAnalyticsEvent(Category.Error, "onCancelOrderError", { error: error });
};
var onCreateOrderRejected = function () {
    sendAnalyticsEvent(Category.Error, "onCreateOrderRejected");
};
var onOpenConfirmationModal = function () {
    sendAnalyticsEvent(Category.ConfirmationPanel, "onOpenConfirmationModal");
};
var sendAnalyticsEvent = function (category, action, data) {
    if (data === void 0) { data = {}; }
    if (process.env.NODE_ENV === "development")
        return;
    var lib = store_1.useTwapStore.getState().lib;
    try {
        fetch("https://bi.orbs.network/putes/twap-ui", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(__assign({ timestamp: new Date().toISOString(), maker: lib === null || lib === void 0 ? void 0 : lib.maker, partner: lib === null || lib === void 0 ? void 0 : lib.config.partner, chain: lib === null || lib === void 0 ? void 0 : lib.config.chainId, category: category, action: action }, data)),
        });
    }
    catch (error) {
        console.error(error);
    }
};
exports.analytics = {
    onLimitToggleClick: onLimitToggleClick,
    onSrcTokenClick: onSrcTokenClick,
    onDstTokenClick: onDstTokenClick,
    onCustomIntervalClick: onCustomIntervalClick,
    onApproveClick: onApproveClick,
    onApproveSuccess: onApproveSuccess,
    onWrapClick: onWrapClick,
    onWrapSuccess: onWrapSuccess,
    onConfirmationCreateOrderClick: onConfirmationCreateOrderClick,
    onODNPClick: onODNPClick,
    onCreateOrderSuccess: onCreateOrderSuccess,
    onCreateOrderError: onCreateOrderError,
    onWrapError: onWrapError,
    onApproveError: onApproveError,
    onCancelOrderClick: onCancelOrderClick,
    onCancelOrderSuccess: onCancelOrderSuccess,
    onCancelOrderError: onCancelOrderError,
    onTwapPageView: onTwapPageView,
    onCreateOrderRejected: onCreateOrderRejected,
    onModuleLoad: onModuleLoad,
    onOpenConfirmationModal: onOpenConfirmationModal,
    uiCrashed: uiCrashed,
};
